import { render, staticRenderFns } from "./contactInfo.vue?vue&type=template&id=92d5aada"
import script from "./contactInfo.vue?vue&type=script&lang=js"
export * from "./contactInfo.vue?vue&type=script&lang=js"
import style0 from "./contactInfo.vue?vue&type=style&index=0&id=92d5aada&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports